<template>
  <div class="container">
    <div class="accounts">
      <p class="accounts__header">
        {{ $t('account.listAccounts', { count: inputAccs }) }}
      </p>

      <textarea
        v-model="listAccs"
        ref="inputAccs"
        :readonly="waitResponse"
        id="inputAccs"
        spellcheck="false"
      ></textarea>

      <div
        style="
          display: flex;
          flex-direction: row;
          align-items: center;
          gap: 10px;
          flex-wrap: wrap;
        "
      >
        <button
          class="btn btn__check unselect ld-ext-right"
          ref="checkAccounts"
          @click="checkAccount"
          :class="{
            loading: waitResponse,
            running: waitResponse,
          }"
          :disabled="!listAccs.length || waitResponse"
        >
          {{ $t('global.check') }}
          <div class="ld ld-ring ld-spin-fast"></div>
        </button>
        <button
          @click="clearListAccs"
          :disabled="waitResponse"
          class="btn btn__clear unselect"
        >
          {{ $t('global.clear') }}
        </button>
        <!-- <button class="btn btn__test unselect">Тест</button> -->

        <label class="check-friends unselect"
          >{{ $t('account.checkFriends') }}
          <input type="checkbox" v-model="checkFriends" />
          <span class="checkmark"></span>
        </label>
      </div>
    </div>

    <div class="result">
      <p class="result__header">
        {{
          $t('global.checkResult', {
            percent: task.percent,
            time: formatCheckedTime,
          })
        }}
      </p>

      <DynamicScroller
        :items="task.data"
        :min-item-size="22"
        @scroll.self="syncIO"
        ref="scroller"
        class="textarea"
        style="padding: 10px 0"
      >
        <template v-slot="{ item, index, active }">
          <DynamicScrollerItem
            :item="item"
            :active="active"
            :size-dependencies="[item.account]"
            :data-index="index"
          >
            <div class="res">
              <span class="line unselect">{{ index + 1 }}.</span>
              <a
                :href="item.profileLink"
                :class="{ 'crossed-text': item.status.name === 'noexist' }"
                target="_blank"
                >{{ item.account }}</a
              >
              →
              <span
                :class="{
                  valid: item.status.name === 'valid',
                  invalid: item.status.name === 'invalid',
                  nonexistent: item.status.name === 'noexist',
                }"
                >{{ item.status.message }}
              </span>
              <span
                v-if="
                  item.status.name === 'valid' && item.friends !== undefined
                "
                style="align-items: center; display: flex"
              >
                <svg
                  viewBox="0 0 28 28"
                  height="16"
                  width="16"
                  style="fill: steelblue; margin: 0 4px 0 0"
                >
                  <path
                    d="M20.34 22.428c.077-.455.16-1.181.16-2.18 0-1.998-.84-3.981-2.12-5.41-.292-.326-.077-.838.36-.838h2.205C24.284 14 27 16.91 27 20.489c0 1.385-1.066 2.51-2.378 2.51h-3.786a.496.496 0 01-.495-.571zM20 13c-1.93 0-3.5-1.794-3.5-4 0-2.467 1.341-4 3.5-4s3.5 1.533 3.5 4c0 2.206-1.57 4-3.5 4zm-9.5-1c-2.206 0-4-2.019-4-4.5 0-2.818 1.495-4.5 4-4.5s4 1.682 4 4.5c0 2.481-1.794 4.5-4 4.5zm2.251 2A6.256 6.256 0 0119 20.249v1.313A2.44 2.44 0 0116.563 24H4.438A2.44 2.44 0 012 21.562v-1.313A6.256 6.256 0 018.249 14h4.502z"
                  ></path>
                </svg>
                <span
                  :class="{
                    friends_count: item.friends.isOpen,
                    friends_hidden: !item.friends.isOpen,
                    friends_error: item.friends.message === 'Error',
                  }"
                >
                  {{
                    item.friends.isOpen
                      ? item.friends.count
                      : item.friends.message
                  }}
                </span>
              </span>
            </div>
          </DynamicScrollerItem>
        </template>
      </DynamicScroller>

      <!-- <div
        @scroll="syncIO"
        ref="results"
        class="textarea"
        id="scrollArea"
        spellcheck="false"
        style="padding: 10px 0 10px 0"
      >
        <div id="contentArea" ref="contentArea" v-if="task.data.length">
          <div class="res" v-for="(item, index) in task.data" :key="item.id">
            <span class="line unselect">{{ index + 1 }}.</span>
            <a
              :href="item.profileLink"
              :class="{ 'crossed-text': item.status.name === 'noexist' }"
              target="_blank"
              >{{ item.account }}</a
            >
            →
            <span
              :class="{
                valid: item.status.name === 'valid',
                invalid: item.status.name === 'invalid',
                nonexistent: item.status.name === 'noexist',
              }"
              >{{ item.status.message }}
            </span>
            <span
              v-if="item.status.name === 'valid' && item.friends !== undefined"
              style="align-items: center; display: flex"
            >
              <svg
                viewBox="0 0 28 28"
                height="16"
                width="16"
                style="fill: steelblue; margin: 0 4px 0 0"
              >
                <path
                  d="M20.34 22.428c.077-.455.16-1.181.16-2.18 0-1.998-.84-3.981-2.12-5.41-.292-.326-.077-.838.36-.838h2.205C24.284 14 27 16.91 27 20.489c0 1.385-1.066 2.51-2.378 2.51h-3.786a.496.496 0 01-.495-.571zM20 13c-1.93 0-3.5-1.794-3.5-4 0-2.467 1.341-4 3.5-4s3.5 1.533 3.5 4c0 2.206-1.57 4-3.5 4zm-9.5-1c-2.206 0-4-2.019-4-4.5 0-2.818 1.495-4.5 4-4.5s4 1.682 4 4.5c0 2.481-1.794 4.5-4 4.5zm2.251 2A6.256 6.256 0 0119 20.249v1.313A2.44 2.44 0 0116.563 24H4.438A2.44 2.44 0 012 21.562v-1.313A6.256 6.256 0 018.249 14h4.502z"
                ></path>
              </svg>
              <span
                :class="{
                  friends_count: item.friends.isOpen,
                  friends_hidden: !item.friends.isOpen,
                  friends_error: item.friends.message === 'Error',
                }"
              >
                {{
                  item.friends.isOpen
                    ? item.friends.count
                    : item.friends.message
                }}
              </span>
            </span>
          </div>
        </div>
      </div> -->

      <div
        v-if="task.data.length"
        style="
          display: flex;
          flex-direction: row;
          align-items: center;
          gap: 10px;
          flex-wrap: wrap;
          justify-content: space-between;
        "
      >
        <div class="res-counts unselect">
          <div
            v-if="task.info.valid"
            v-tippy="{
              content: 'Скопировать активные',
              hideOnClick: false,
              theme: 'material',
              animation: 'shift-away',
              onHidden(instance) {
                instance.setContent('Скопировать активные');
              },
            }"
            @click="copyResult($event, 'valid')"
            class="res-counts__block"
          >
            <span class="res-counts__block-status active"></span>
            {{ task.info.valid }} • {{ statusPercent(task.info.valid) }}%
          </div>

          <div
            v-if="task.info.invalid"
            v-tippy="{
              content: 'Скопировать заблокированные',
              hideOnClick: false,
              theme: 'material',
              animation: 'shift-away',
              onHidden(instance) {
                instance.setContent('Скопировать заблокированные');
              },
            }"
            @click="copyResult($event, 'invalid')"
            class="res-counts__block"
          >
            <div class="res-counts__block-status blocked"></div>
            {{ task.info.invalid }} • {{ statusPercent(task.info.invalid) }}%
          </div>

          <div
            v-if="task.info.noExist"
            v-tippy="{
              content: 'Скопировать несуществующие',
              hideOnClick: false,
              theme: 'material',
              animation: 'shift-away',
              onHidden(instance) {
                instance.setContent('Скопировать несуществующие');
              },
            }"
            @click="copyResult($event, 'noexist')"
            class="res-counts__block"
          >
            <div class="res-counts__block-status noexist"></div>
            {{ task.info.noExist }} • {{ statusPercent(task.info.noExist) }}%
          </div>

          <div
            v-if="task.info.errors"
            v-tippy="{
              content: 'Скопировать ошибочные',
              hideOnClick: false,
              theme: 'material',
              animation: 'shift-away',
              onHidden(instance) {
                instance.setContent('Скопировать ошибочные');
              },
            }"
            @click="copyResult($event, 'error')"
            class="res-counts__block"
          >
            <span class="res-counts__block-status error"></span>
            {{ task.info.errors }} • {{ statusPercent(task.info.errors) }}%
          </div>
        </div>

        <div style="display: flex; align-items: center; gap: 10px">
          <button
            v-tippy="{
              content: tippyCopyResultContent,
              hideOnClick: false,
              theme: 'material',
              animation: 'shift-away',
              onHidden(instance) {
                tippyCopyResultContent = 'Скопировать результат';
              },
            }"
            @click="copyFullResult"
            class="btn btn__copy unselect"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              viewBox="0 0 24 24"
              style="fill: white"
            >
              <path
                d="M14 8H4c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2h10c1.103 0 2-.897 2-2V10c0-1.103-.897-2-2-2z"
              ></path>
              <path
                d="M20 2H10a2 2 0 0 0-2 2v2h8a2 2 0 0 1 2 2v8h2a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2z"
              ></path>
            </svg>
          </button>

          <button
            v-if="!waitResponse"
            @click="exportCSV"
            :disabled="waitResponseCSV"
            :class="{
              loading: waitResponseCSV,
              running: waitResponseCSV,
            }"
            class="btn btn__export unselect ld-ext-right"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              viewBox="0 0 24 24"
              style="fill: white; transform: ; msfilter: "
            >
              <path d="M11 16h2V7h3l-4-5-4 5h3z"></path>
              <path
                d="M5 22h14c1.103 0 2-.897 2-2v-9c0-1.103-.897-2-2-2h-4v2h4v9H5v-9h4V9H5c-1.103 0-2 .897-2 2v9c0 1.103.897 2 2 2z"
              ></path>
            </svg>
            {{ $t('global.export') }}
            <div class="ld ld-ring ld-spin-fast"></div>
          </button>
        </div>
      </div>
    </div>

    <a class="hide" ref="exportLink"></a>
  </div>

  <Modal :showPassword="true" :backdropClick="false">
    <template #header> Ваш пароль успешно создан </template>
    <template #body>
      <p>
        Скопируйте пароль в надежное место, после чего окно можно будет закрыть.
      </p>
    </template>
  </Modal>

  <Modal ref="connectTg">
    <template #header> Подтвердите доступ </template>
    <template #body>
      <p>
        Чтобы использовать тариф Free, подключите в 2 клика наш
        <a href="https://t.me/checkerFBRIPbot" target="_blank">Telegram Bot</a>.
      </p>
      <p>
        Если у вас нет Telegram аккаунта, скачайте и установите мессенджер на
        <a href="https://telegram.org" target="_blank">официальном сайте</a>.
      </p>
      <p>
        Если хотите использовать платные тарифы от $5, которые не требуют
        подключения к боту, перейдите на
        <a href="" @click.prevent="this.$router.push('/pay')">страницу оплаты</a
        >.
      </p>
    </template>
  </Modal>
</template>

<script>
import Modal from '@/components/Modal.vue';
import moment from 'moment';
import { directive } from 'vue-tippy';

export default {
  components: {
    Modal
  },

  directives: {
    tippy: directive
  },

  data() {
    return {
      waitResponse: false,
      waitResponseCSV: false,
      listAccs: '',
      listAccsArray: [],
      task: {
        percent: 0,
        data: [],
        info: {}
      },
      checkFriends: false,
      tippyCopyResultContent: 'Скопировать результат'
    };
  },

  computed: {
    inputAccs() {
      return this.listAccs.split('\n').filter(n => n).length;
    },

    formatCheckedTime() {
      const time = this.task.info.checkedTime;

      if (time) {
        return moment
          .utc(moment.duration(time, 'seconds').asMilliseconds())
          .format('mm:ss');
      } else {
        return '00:00';
      }
    }
  },

  methods: {
    clearListAccs() {
      this.listAccs = '';
      this.listAccsArray = [];
      this.task.data = [];
      this.task.percent = 0;
      this.task.info = {};
      // Очистка тем даты
      delete localStorage.accountsData;

      this.$refs.inputAccs.focus();
    },

    syncIO({ target }) {
      const { scrollTop } = target;

      this.$refs.inputAccs.scrollTop = scrollTop;
      // this.$refs.results.scrollTop = scrollTop;
    },

    filterAccounts(account) {
      // console.log(account);

      const re1 = /^(http|https):\/\/(.*?)\.facebook.com\/(profile\.php\?id=(\d+)|[A-Za-z.0-9]{4,50})$/g;
      const re2 = /^[A-Za-z.0-9]{4,50}$/g;

      if (Number(account) || account.match(re1) || account.match(re2)) {
        return account;
      } else {
        return;
      }
    },

    makeid(length) {
      var result = '';
      var characters = 'abcdefghijklmnopqrstuvwxyz0123456789';
      var charactersLength = characters.length;
      for (var i = 0; i < length; i++) {
        result += characters.charAt(
          Math.floor(Math.random() * charactersLength)
        );
      }
      return result;
    },

    async checkAccount() {
      this.waitResponse = true;
      this.listAccsArray = [];
      this.task.data = [];
      this.task.percent = 0;
      this.task.info = {};

      // Удаляем дубли, пробелы в списке акков, лишние символы в начале/конце строки и обновляем список
      const uidList = [
        ...new Set(
          this.listAccs
            .split('\n')
            .map(s =>
              s
                .replace(/^[\W_]+|[\W_]+$/g, '')
                .trim()
                .toLowerCase()
            )
            .filter(n => this.filterAccounts(n))
        )
      ];

      // const uidList = this.listAccs.split('\n');

      const requestId = this.makeid(16);

      this.listAccs = uidList.join('\n').trim();
      this.listAccsArray = uidList;

      // Разбиваем список аккаунтов на части
      const perChunk = 100;
      const uidListChunk = uidList.reduce(
        (chunks, el, i) =>
          (i % perChunk
            ? chunks[chunks.length - 1].push(el)
            : chunks.push([el])) && chunks,
        []
      );

      // console.log(uidList);
      // console.log(uidListChunk);

      // Отправляем запрос
      for (const list of uidListChunk.values()) {
        try {
          let chk = this.checkFriends;
          let lsu = localStorage.userLang;

          console.log({ list, chk, lsu, requestId });

          const response = await this.axios.post('check/account', {
            inputData: list,
            checkFriends: this.checkFriends,
            userLang: localStorage.userLang,
            requestId: requestId
          });

          if (response.data.error) {
            // throw new Error(response.data.error);
            if (response.data.error.code === 'noConnectTg') {
              this.$refs.connectTg.openModal();
            } else {
              this.showToaster(response.data.error.message);
            }

            break;
          }

          this.task.data.push(...response.data.data);

          if (!this.task.info) {
            this.task.info = response.data.info;
          } else {
            const sumValueByKey = (...rest) =>
              rest.reduce((result, current) => {
                for (const key in current) {
                  const value = current[key];

                  if (result[key] === undefined) {
                    result[key] = value;
                  } else {
                    result[key] += value;
                  }
                }

                return result;
              }, {});

            this.task.info = sumValueByKey(this.task.info, response.data.info);
          }

          // Вычисляем % выполнения задачи
          this.task.percent = Math.round(
            (this.task.data.length / uidList.length) * 100
          );
        } catch (err) {
          // alert(err.message);
          this.showToaster(err.message);
          break;
        }
      }

      // Подгружаем актуальные данные по пользователю
      // this.axios.get('user/me').then((resp) => {
      //   this.$store.state.user = resp.data.user;
      //   localStorage.userInfo = JSON.stringify(resp.data.user);
      // });

      // Сохраняем темп дату, если данных меньше 10к
      if (this.task.data.length <= 10000) {
        localStorage.accountsData = JSON.stringify({
          in: this.listAccs,
          inArray: this.listAccsArray,
          out: this.task
        });

        console.log('save accs');
      }

      // Разблокировка кнопок и полей
      this.waitResponse = false;
    },

    statusPercent(count) {
      return Math.round((count / this.listAccsArray.length) * 100);
    },

    copyResult(event, status) {
      const accounts = {};

      accounts.data = this.task.data
        .filter(a => a.status.name === status)
        .map(v => v.origin)
        .join('\n');

      navigator.clipboard
        .writeText(accounts.data)
        .then(() => {
          console.log('copy');
          event.target._tippy.setContent('Скопировано');
          return true;
        })
        .catch(() => {
          console.log('error copy');
          event.target._tippy.setContent('Ошибка копирования');
          return false;
        });
    },

    async copyFullResult() {
      const results = this.task.data
        .map(v => {
          const friends = v.friends?.count !== undefined ? v.friends.count : '';
          return `${v.origin} ${v.status.name} ${friends}`.trim();
        })
        .join('\n');

      try {
        navigator.clipboard.writeText(results);
        console.log('copy full result');
        this.tippyCopyResultContent = 'Скопировано';
      } catch (err) {
        console.log('error copy full result');
        this.tippyCopyResultContent = 'Ошибка копирования';
      }
    },

    async exportCSV() {
      this.waitResponseCSV = true;
      const exportDate = moment().format();

      const res = this.task.data;
      const rows = [['account', 'status', 'friends', 'uid', 'profile link']];

      for (const index in res) {
        let countFriends = '';

        // Если аккаунт с данными о друзьях, обрабатываем его
        if (res[index].friends !== undefined) {
          if (res[index].friends.isOpen) {
            countFriends = res[index].friends.count;
          } else {
            countFriends = res[index].friends.message.toLowerCase();
          }
        }

        rows.push([
          res[index].account,
          res[index].status.name,
          countFriends,
          res[index].uid,
          res[index].profileLink
        ]);
      }

      const csvContent = rows.map(e => e.join(',')).join('\n');

      const blob = new Blob([csvContent], { type: 'csv/plain' });
      const link = this.$refs.exportLink;
      link.href = window.URL.createObjectURL(blob);
      link.download = `export_accounts.${exportDate}(checker.fb.rip).csv`;
      link.click();
      this.waitResponseCSV = false;
    },

    showToaster(msg) {
      this.$toast.show(msg, {
        position: 'top'
        // duration: false,
      });
    }
  },

  mounted() {
    this.$refs.inputAccs.focus();
    const accountsData = localStorage.accountsData;

    if (accountsData && JSON.parse(accountsData).in) {
      this.listAccs = JSON.parse(accountsData).in;
      this.listAccsArray = JSON.parse(accountsData).inArray;
    }

    if (accountsData && JSON.parse(accountsData).out) {
      this.outputData = JSON.parse(accountsData).out;
      this.task = JSON.parse(accountsData).out;
    }
  }
};
</script>

<style scoped>
.hide {
  display: none;
}
/* The container */
.check-friends {
  display: flex;
  position: relative;
  padding-left: 35px;
  cursor: pointer;
  height: 25px;
  align-items: center;
}

/* Hide the browser's default checkbox */
.check-friends input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create a custom checkbox */
.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 25px;
  width: 25px;
  background-color: #eee;
  border-radius: 5px;
}

/* On mouse-over, add a grey background color */
.check-friends:hover input ~ .checkmark {
  background-color: #ccc;
}

/* When the checkbox is checked, add a blue background */
.check-friends input:checked ~ .checkmark {
  /* background-color: #2196f3; */
  background-color: #018cba;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: '';
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.check-friends input:checked ~ .checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */
.check-friends .checkmark:after {
  left: 9px;
  top: 5px;
  width: 5px;
  height: 10px;
  border: solid white;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}
</style>
